import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { ModulesModule } from './modules/modules.module';
import { PipesModule } from './pipes/pipes.module';
import { ValidatorsModule } from './validators/validators.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectivesModule,
    PipesModule,
    ValidatorsModule,
    ModulesModule,
  ],
  exports: [
    ComponentsModule,
    DirectivesModule,
    PipesModule,
    ValidatorsModule,
    ModulesModule,
  ],
})
export class SharedModule {}
